import { useContext } from "react";
import { UserLogin } from "../../pages/Login";
import { AuthContext } from "./ProviderContext";

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const auth = useContext(AuthContext);

  if (!auth.user) {
    return <UserLogin />;
  }

  return children;
};
